<template>
  <div class="credit-card-input">
    <div
      class="credit-card-title text-secondary"
      v-text="$t('payment.enter-card-details')"
    />
    <div class="credit-card-form">
      <form
        id="form-container"
        method="post"
        @submit.prevent="createToken"
      >
        <div id="element-container" />
      </form>
    </div>
  </div>
</template>

<script>
import { Tapjsli } from '@/libs/tap'
import { TAP_TOKEN } from '@/constants/config'

export default {
  name: 'CreditCardInput',
  data() {
    return {
      tap: new Tapjsli(TAP_TOKEN),
      card: null,
      error: '',
    }
  },
  mounted() {
    this.initCard()
  },
  methods: {
    initCard() {
      const elements = this.tap.elements({})

      const style = {
        base: {
          color: '#232223',
          lineHeight: '18px',
          fontFamily: 'sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: 'rgba(0, 0, 0, 0.55)',
            fontSize: '15px',
          },
        },
        invalid: {
          color: 'red',
        },
      }

      const labels = {
        cardNumber: 'Card Number',
        expirationDate: 'MM/YY',
        cvv: 'CVV',
        cardHolder: 'Card Holder Name',
      }

      const paymentOptions = {
        currencyCode: ['KWD', 'USD', 'SAR', 'EUR', 'AED'],
        labels,
        TextDirection: this.$store.getters['appConfig/isRTL'] ? 'rtl' : 'ltr',
      }

      this.card = elements.create('card', { style }, paymentOptions)
      this.card.mount('#element-container')
    },
    createToken() {
      return new Promise((resolve, reject) => {
        this.tap
          .createToken(this.card)
          .then(result => {
            if (result.error) {
              this.error = result.error.message
              reject(result.error)
            } else {
              resolve(result.id)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
  },
}
</script>

<style lang="scss">
.credit-card-input {
  margin: 30px 0;
  .credit-card-title {
    margin-bottom: 31px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }
}
</style>
